import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	todayTooltip: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.roadmap.today-button.today-tooltip',
		defaultMessage: 'Go to today',
		description: 'Text for today tooltip',
	},
});
